<template>
  <CommonHeader class="main_head_block">
    <template v-slot:header>
      <div class="module_heading" style="white-space: nowrap;width:auto;">
        Campaign Groups
      </div>
      <div>
        <!-- <button
          class="btn btn-primary add-new-campaign"
          @click="openEditCampaign()"
        >
          
        </button> -->
        <div class="add_icon_container" @click ="openEditCampaign()">
          		<i class="fas fa-plus icon_add" ></i>
      		</div>
        
      </div>
      <div class="sel_fil_wrap one">
        <multiselect
          v-model="clientData"
          :options="clientList"
          label="client_name"
          :searchable="true"
          ref="multiselect"
          track-by="client_name"
          open-direction="bottom"
          class="form-control multi-dropdown select_filter"
          placeholder="All Client"
          selectLabel
          deselectLabel
          selectedLabel
          :showLabels="true"
          :multiple="false"
          id="mutiselect"
          @select="getCampaignGroupList"
          @remove="resetFilter('clientRemoved')"
        />
      </div>
      <div class="sel_fil_wrap two">
        <multiselect
          v-model="selectedBrand"
          :options="brandDropDown"
          :show-no-results="true"
          :searchable="true"
          ref="multiselect"
          label="name"
          track-by="id"
          open-direction="bottom"
          :taggable="false"
          placeholder="Profiles"
          class="form-control multi-dropdown select_filter"
          selectLabel
          deselectLabel
          selectedLabel
          @select="getCampaignGroupListForProfile"
          @remove="resetFilter()"
        />
      </div>
      <div
        class="head_search"
      >
        <object
          data="assets/img/search.svg"
          style="height: 18px; width: 18px; margin-left: 5px"
        ></object>
      </div>
      <div class="ghost"
				@click="getFilterCampaignGroupList()"
			>
      </div>
      <div class="head_search_inp">
        <input
          type="search"
          id="search"
          class="search"
          v-model="searchFilterString"
          placeholder="Name"
          @keyup.enter="getFilterCampaignGroupList()"
          style="border: none; outline: none; padding: 7px 0px 5px 10px"
          autocomplete="off"
        />
      </div>
    </template>
  </CommonHeader>
</template>


<script>
import CommonHeader from "@/components/CommonHeader.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "CampaignGroupHeader",
  data() {
    return {
      name: "",
      id: "null",
      selectedVendorList: [],
    };
  },
  props: {},
  mounted() {
    if (
      !this.clientList ||
      this.clientList.length == 0 ||
      (this.clientData &&
        this.clientData.client_id &&
        this.brandDropDown.length == 0)
    ) {
      this.getClientList();
    }
    if (
      this.$store.state.selectedVendorFilter &&
      this.$store.state.vendorList
    ) {
      this.selectedVendorList = this.$store.state.vendorList.filter(
        (e) => e.id == this.$store.state.selectedVendorFilter
      );
    }
  },
  components: {
    Multiselect,
    CommonHeader,
  },
  computed: {
    // selectedVendorList: {
    // 	set(val) {
    // 		this.$store.commit("setSelectedVendorFilter", val);
    // 	},
    // 	get() {
    // 		return this.$store.getters["getSelectedVendorFilter"];
    // 	}
    // },
    brandDropDown: {
      set(val) {
        if (val) this.$store.state.brandPerClient = val;
        else this.$store.state.brandPerClient = [];
      },
      get() {
        return this.$store.state.brandPerClient;
      },
    },
    vendorsList() {
      let data = this.$store.state.vendorList.filter((e) => e.name);
      if (data && data.length && data[0].id != "all")
        data.unshift({ id: "all", name: "All Vendor" });
      return data;
    },
    brandList() {
      let data = this.brandDropDown.filter((e) => e.name);
      // if(data && data.length && data[0].id!="all")
      // data.unshift({id:"all", name:"All Profiles"})
      return data;
    },
    brandProfileList: {
      set(val) {
        this.$store.state.brandProfileList = val;
      },
      get() {
        return this.$store.state.brandProfileList;
      },
    },
    searchFilterString: {
      set(val) {
        if (!val) {
          this.$store.state.searchFilterString = val;
          this.getFilterCampaignGroupList();
        } else {
          this.$store.state.searchFilterString = val;
        }
        //sessionStorage.setItem("campaignGroup:searchFilterString", val);
      },
      get() {
        // if (
        // 	sessionStorage.getItem("campaignGroup:searchFilterString")
        // ) {
        // 	return sessionStorage.getItem(
        // 		"campaignGroup:searchFilterString"
        // 	);
        // } else {
        return this.$store.state.searchFilterString;
        //}
      },
    },
    selectedSortOrder: {
      set(val) {
        sessionStorage.setItem("campaignGroup:selectedSortOrder", val);
        //this.$store.state.selectedSortOrder = val
      },
      get() {
        if (sessionStorage.getItem("campaignGroup:selectedSortOrder")) {
          return sessionStorage.getItem("campaignGroup:selectedSortOrder");
        } else {
          return this.$store.state.selectedSortOrder;
        }
      },
    },
    clientList: {
      set(val) {
        if (val) {
          this.$store.state.clientList = val;
        }
      },
      get() {
        return this.$store.state.clientList || [];
      },
    },
    clientData: {
      set(val) {
        if (val) {
          this.$store.state.clientData = val;
        } else {
          this.$store.state.clientData = null;
        }
      },
      get() {
        return this.$store.state.clientData;
      },
    },
    selectedBrand: {
      set(data) {
        if (data && data.id == "all") {
        } else {
          this.$store.state.selectedBrandProfle = (data || {}).id;
        }
      },
      get() {
        if (
          this.$store.state.profileBrandList.length &&
          this.$store.state.selectedBrandProfle
        ) {
          let tempBrandProfile = this.$store.state.profileBrandList.filter(
            (brand) => brand["id"] == this.$store.state.selectedBrandProfle
          );
          return tempBrandProfile;
        } else {
          return [];
        }
      },
    },
  },
  methods: {
    resetBrand() {
      this.brandDropDown = [];
      this.selectedBrand = [];
    },
    getClientList() {
      const vm = this;
      this.$store.dispatch("getAccountClient").then((res) => {
        vm.clientList = res.filter((e) => e.client_name);
        if (vm.clientData) {
          let pay = {
            go_client_id: vm.clientData.client_id,
          };
          this.$store
            .dispatch("campaign/fetchBrandByClient", pay)
            .then((res) => {
              this.brandDropDown = res ? res : [];
            });
        }
      });
    },
    getFilterCampaignGroupList(data) {
      this.$store.state.campaign.actionSelectioncampaignGroupControl = false;
      this.$store.state.campaign.campaignGroupSelectedList = [];
      this.$store.state.currentPageNumber = 1;
      var pay = {
        go_client_id: data
          ? data.client_id
          : this.clientData
          ? this.clientData.client_id
          : "",
      };
      this.$store.dispatch("campaign/getCampaignGroupList", pay);
      if (this.selectedBrand.length == 0 && data.client_id) {
        let pay = {
          go_client_id: data.client_id,
        };
        this.$store.dispatch("campaign/fetchBrandByClient", pay).then((res) => {
          this.brandDropDown = res ? res : [];
        });
      }
    },
    openEditCampaign() {
      this.$emit("showEditCampaign", this.id);
    },
    getCampaignGroupList(data) {
      if (data.id == "all") {
        this.$store.dispatch("profileBrandList");
        this.resetFilter();
      } else {
        this.brandDropDown = [];
        this.selectedBrand = [];
        this.$store.state.selectedVendorFilter = data.id;
        this.getFilterCampaignGroupList(data);
      }
    },
    getCampaignGroupListForProfile(data) {
      this.$store.state.campaign.actionSelectioncampaignGroupControl = false;
      this.$store.state.campaign.campaignGroupSelectedList = [];
      if (data.id == "all") {
        this.$store.dispatch("profileBrandList");
        this.resetFilter();
      } else {
        this.$store.state.selectedBrandProfle = data.id;
        this.getFilterCampaignGroupList();
      }
    },
    resetFilter(clientRemoved) {
      if (clientRemoved) {
        this.clientData = null;
        this.resetBrand();
      }
      this.$store.state.campaign.actionSelectioncampaignGroupControl = false;
      this.$store.state.campaign.campaignGroupSelectedList = [];
      this.selectedBrand = [];
      this.selectedVendorList = [];
      this.$store.state.selectedBrandProfle = "";
      this.$store.state.selectedVendorFilter = "";
      // this.clientData = null
      // this.clientList = []
      this.getFilterCampaignGroupList();
    },
  },
};
</script>
